import React from 'react';

import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions
} from '@mui/material';
import { useDialogControl } from 'modules/layer0';

import * as dataService from './dataService';



export const FC: React.FC = () => {
  const control = useDialogControl({});
  const { data, mutations, loading } = dataService.useCancelSubscriptionModal();

  let buttonText = '';
  if (data.hasSubscription && !data.willCancelAtPeriodEnd) {
    buttonText = 'Cancel Subscription';
  } else if (data.willCancelAtPeriodEnd) {
    buttonText = `Ends on ${data.periodEnd.format('MMM d')}`;
  } else {
    buttonText = 'No subscription';
  }

  return (
    <>
      <Button
        disabled={!data.hasSubscription || data.willCancelAtPeriodEnd}
        variant="outlined"
        color="error"
        onClick={control.openDialog}>
        {buttonText}
      </Button>

      <Dialog
        open={control.isOpen}
        onClose={control.closeDialog}
        maxWidth="xs">
        <DialogTitle>Are you sure?</DialogTitle>

        <DialogContent>
          <Typography>
            This action will cancel your subscription before the next billing cycle. Once your subscription has expired, you will no longer be able to access Ridge. Are you sure?
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            disabled={loading}
            variant="outlined"
            color="secondary"
            onClick={control.closeDialog}>
            Cancel
          </Button>

          <Button
            disabled={loading}
            onClick={async () => {
              await mutations.cancelSubscription();
              control.closeDialog();
            }}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );

};
